<sc-loading-spinner [isLoading]="isLoading" [fitHeight]="true">
    <sc-padding [fitHeight]="true">
        <sc-flex [fitHeight]="true" [stretchContent]="true" [vertical]="true">
            <div>
                <form [formGroup]="formGroup">
                    <sc-flex [stretchContent]="true" [centered]="true">
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Name' | translate: ['erp.entity.project.name',
                                translationService.language]}}</mat-label>
                            <input matInput formControlName="name">
                        </mat-form-field>
                        <sc-content-spacer></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Datum Start' | translate: ['erp.entity.project.start-date',
                                translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="startDate" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Datum Ende' | translate: ['erp.entity.project.end-date',
                                translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="endDate" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer></sc-content-spacer>
                        <mat-checkbox name="archived" formControlName="archived">
                            {{'archived' | translate: ['erp.entity.project.archived', translationService.language]}}
                        </mat-checkbox>
                        <sc-content-spacer></sc-content-spacer>
                        <button mat-flat-button (click)="onSearchProjects()" [disabled]="!searchProjectsEnabled">
                            {{ 'find projects' | translate: ['erp.ui.add-project.action.search',
                            translationService.language]}}
                        </button>
                    </sc-flex>
                </form>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-flex-fitting-content [vertical]="true">
                <sc-scroll-pane>
                    <table mat-table [dataSource]="datasource">

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>{{'name' | translate:
                                ['erp.entity.project.name', translationService.language]}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="start-date">
                            <th mat-header-cell *matHeaderCellDef>{{'start date' | translate:
                                ['erp.entity.project.start-date', translationService.language]}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.startDate}} </td>
                        </ng-container>

                        <ng-container matColumnDef="end-date">
                            <th mat-header-cell *matHeaderCellDef>{{'end date' | translate:
                                ['erp.entity.project.end-date', translationService.language]}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.endDate}} </td>
                        </ng-container>

                        <ng-container matColumnDef="archived">
                            <th mat-header-cell *matHeaderCellDef>{{'archived' | translate:
                                ['erp.entity.project.archived', translationService.language]}} </th>
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element.archived">
                                    <sc-icon iconClass="fa-check"></sc-icon>
                                </ng-container>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button (click)="selectProject(element)">
                                    <sc-action-icon iconClass="fa-pen"> </sc-action-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </sc-scroll-pane>
            </sc-flex-fitting-content>
        </sc-flex>
    </sc-padding>
</sc-loading-spinner>
